var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_484_9982",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 17,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 2.875H3.5625C3.24756 2.875 2.94551 3.00011 2.72281 3.22281C2.50011 3.44551 2.375 3.74756 2.375 4.0625V15.9375C2.375 16.2524 2.50011 16.5545 2.72281 16.7772C2.94551 16.9999 3.24756 17.125 3.5625 17.125H15.4375C15.7524 17.125 16.0545 16.9999 16.2772 16.7772C16.4999 16.5545 16.625 16.2524 16.625 15.9375V4.0625C16.625 3.74756 16.4999 3.44551 16.2772 3.22281C16.0545 3.00011 15.7524 2.875 15.4375 2.875Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3138 12.7708L10.293 14.3542L13.4596 10.3958M5.54297 6.4375H13.4596M5.54297 9.60417H8.70964",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_484_9982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H19V19.5H0V0.5Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransaction);
export default __webpack_public_path__ + "static/media/icon-transaction.e9d9eb05ad96b86e7f9aaf08b0674afb.svg";
export { ForwardRef as ReactComponent };